import Layout from '@/components/common/layout'
import AppRoutes from '@/routes/AppRoutes'
import { BrowserRouter as Router } from 'react-router-dom'
import Loading from '@/components/common/loading'
import GlobalStyle from '@/styles/global'
import ErrorBoundary from './components/error/ErrorBoundary'

function App() {
  
  return (
    <Router>
      <GlobalStyle />
      <Loading />
      <Layout>
        <ErrorBoundary>
          <AppRoutes />
        </ErrorBoundary>
      </Layout>
    </Router>
  )
}

export default App
